<template>
    <thead class="table-party-header">
        <tr class="table-party-header-row">
            <th class="table-party-header-row-cell" scope="col">
                <span>{{ i18n("views.TableParties.PreferredMinimumSize") }}</span>
            </th>
            <th class="table-party-header-row-cell" scope="col">
                <span>{{ i18n("views.TableParties.MaximumSize") }}</span>
            </th>
            <th class="table-party-header-row-cell" scope="col"></th>
        </tr>
    </thead>
</template>

<script setup lang="ts">
    import { i18n } from "@/portal/Trans";
</script>

<style scoped lang="scss">
    .table-party-header {
        .table-party-header-row {
            
            .table-party-header-row-cell {
                padding: 7.5px;
                
                span {
                    font-weight: 500;
                    color: #595d6e;
                }
            }
        }
    }
</style>
